import mission from '../../assets/Mission.svg'
import vission from '../../assets/Vission.svg'


export const VisionPage = () => {
    return (
        <section className='w-full max-w-[1312px]   space-y-5'>
            <div className='py-6'>
                <h2 className='md:text-[48px] text-[28px] font-semibold p-3 text-center '>Our <span className='text-[#2C25C4]'>Mission</span> & <span className='text-[#8C18C3]'>Vision</span></h2>

                <div className='flex flex-col md:flex-row justify-center gap-10  rounded-md '>

                    <div className='md:w-[646px] md:h-[236px] bg-white p-[36px] rounded-[12px] shadow-xl'  >
                        <div className='flex justify-start gap-4 items-center'>

                            <div className='h-[40px] w-[40px] p-[10px] rounded-[8px]  bg-[#ECF1FF]'><img src={mission} className='w-[18px] h-[18px] text-[#2C25C4]' alt="Mission Icon" /></div>
                            <p className='text-[#2C25C4] text-[20px] font-semibold '>Our Mission</p>
                        </div>
                        <p className='sm:p-[5px]'>To make hiring fast, fair, and future-ready for everyone, everywhere. We believe in creating equal opportunities through
                            technology and eliminating bias in the recruitment process.</p>
                    </div>

                    <div className='md:w-[646px] md:h-[236px] bg-white p-[36px] rounded-[12px] shadow-xl'>
                        <div className='flex justify-start gap-4 items-center'>

                            <div className='h-[40px] w-[40px] p-[10px] rounded-[8px]  bg-[#FBF4FF]' ><img src={vission} className='w-[18px] h-[18px] text-[#2C25C4]' alt="Vision Icon" /></div>
                            <p className='text-[#8C18C3] text-[20px] font-semibold '>Our Vision</p>
                        </div>
                        <p className='sm:p-[10px]'>To be the most reliable career platform where talent and opportunity meet instantly. We envision
                            a world where finding the perfect job or candidate is seamless and efficient.</p>
                    </div>

                </div>
            </div>
        </section>
    )
}
